import { ZoekComponent } from './zoek/zoek.component';
import { Routes } from '@angular/router';

export const zoekenRoutes : Routes = [
    { path: 'zoek', component: ZoekComponent /*,resolve:{soortenzitting:ZoekDataResolver}*/ }    
];

